import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2Off: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideo2Off"><Path d="M2.5 7V18.5H12M8 5.50001L17.5 5.50002V17" stroke="currentColor"/><Path d="M17.5 8.5L22.5 6.5V17.5L17.5 15.5" stroke="currentColor"/><Path d="M2.5 2.5L17.5 21.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconVideo2Off;
